function isPromise(value) {
    return value instanceof Promise;
}

export { isPromise };
